"use client"

import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { colors, mediaQueries, sizes } from "ui"
import { getNonUmbracoUrl } from "utils"
import { ButtonWithArrowTall } from "../common/bit/ButtonWithArrow"
import IconWithBackground from "../common/bit/IconWithBackground"
import { StyledLink } from "./FormsAndActionsComponent/styles"

const StyledInfoListWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${sizes.baseQuadric};
`

const StyledItemsInfoListWrapper = styled(Box)`
  display: flex;
  gap: ${sizes.baseTriple};
  width: 100%;
  ${mediaQueries.tabletDown} {
    display: flex;
    flex-direction: column;
  }

  ${mediaQueries.desktopM} {
    flex-flow: row wrap;
    justify-items: center;
  }
`

const StyledButtonWithArrow = styled(ButtonWithArrowTall)`
  width: 45%;
  margin-bottom: ${sizes.baseDouble};
  border: 1px solid ${colors.lightGray};
  padding: 10px 8px 10px 12px;
  .content {
    flex-direction: row;
    text-align: start;
    align-items: center;
    gap: 10px;
  }
  .title {
    font-size: 18px;
    font-weight: 700;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    ${mediaQueries.tabletDown} {
      font-size: 14px;
    }
  }
  ${mediaQueries.tabletDown} {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 0;
    padding: ${sizes.baseSingle};
  }
  ${mediaQueries.desktopM} {
    box-shadow: none;
  }
  svg {
    width: unset;
    margin-inline-start: auto;
  }
`
interface InfoFormsListProps {
  itemsList: {
    category?: string[]
    itemName?: string
    title?: string
    text?: string
    link?: { name: string; href: string }
    file?: { url: string }
    icon?: { id: number; url: string }
    primaryColor: string
  }[]
  title?: string
  link?: { name: string; href: string }
}

const InfoFormsList = ({ itemsList, title, link }: InfoFormsListProps) => {
  const t = useTranslations("InfoFormsList")
  return (
    <>
      <StyledInfoListWrapper>
        {title && <Typography variant="h4">{title}</Typography>}
        <StyledItemsInfoListWrapper>
          {itemsList.map((item, index) => {
            const { title, itemName, link, icon, primaryColor, file } = item
            const colorName = colors.resolveColorName("#" + primaryColor)
            const ArrowIcon = colors.getArrowIconNoLinesKey("#" + primaryColor)
            return (
              <StyledButtonWithArrow
                key={`accordion-item-${title}-${index}`}
                arrowName={ArrowIcon}
                variant="elevated"
                colorPallette={colorName as any}
                href={getNonUmbracoUrl(file?.url || link?.href)}
                target="_blank"
              >
                {icon?.url && (
                  <IconWithBackground
                    size={48}
                    icon={
                      icon.url && (
                        <Image
                          src={icon.url}
                          alt={`${t("iconAlt")}${link?.name || "icon"}`}
                          fill
                        />
                      )
                    }
                    backgroundColor={primaryColor}
                  />
                )}
                {itemName && (
                  <Typography variant="h3" className="title">
                    {itemName || link?.name}
                  </Typography>
                )}
              </StyledButtonWithArrow>
            )
          })}
        </StyledItemsInfoListWrapper>
        {link && (
          <StyledLink href={getNonUmbracoUrl(link?.href)}>
            {link?.name}
          </StyledLink>
        )}
      </StyledInfoListWrapper>
    </>
  )
}

export default InfoFormsList
